import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { timeIntervalProxy, TimeIntervals } from '../../timeIntervalProxy'
import { proxyGlobalAuth } from '../../../../../../shared/proxies/proxyGlobalAuth'
import { FetchRecentSales } from '../recentSalesProxy'

export function ToggleInterval (): ReactElement {
  const { siteTheme: { toggleTabButtonColors } } = useSnapshot(proxyGlobalAuth)
  const { timeInterval } = useSnapshot(timeIntervalProxy)

  const monthlyActive = timeInterval === TimeIntervals.Monthly
  const weeklyActive = timeInterval === TimeIntervals.Weekly

  const handleWeeklyClick = (): void => {
    timeIntervalProxy.timeInterval = TimeIntervals.Weekly
    void FetchRecentSales(TimeIntervals.Weekly)
  }

  const handleMonthlyClick = (): void => {
    timeIntervalProxy.timeInterval = TimeIntervals.Monthly
    void FetchRecentSales(TimeIntervals.Monthly)
  }

  return (
    <div>
      <span
        className={cn(toggleTabButtonColors.commonClasses, weeklyActive ? toggleTabButtonColors.activeClasses : toggleTabButtonColors.inactiveClasses)}
        onClick={handleWeeklyClick}
      >
        Weekly
      </span>
      <span
        className={cn(toggleTabButtonColors.commonClasses, monthlyActive ? toggleTabButtonColors.activeClasses : toggleTabButtonColors.inactiveClasses)}
        onClick={handleMonthlyClick}
      >
        Monthly
      </span>
    </div>
  )
}
